import _styled from '@emotion/styled/base';
import { badge } from '@tablecheck/tablekit-core';
import { buildComponentWithVariants, buildVariantComponents } from '../buildVariantComponents.js';
var BadgeBase = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e18t43vb0"
} : {
  target: "e18t43vb0",
  label: "BadgeBase"
})(badge.baseStyles, ";");
var Badge = buildComponentWithVariants(badge.variantStyles, BadgeBase, {});
Badge.displayName = 'Badge';
var VariantBadge = buildVariantComponents(badge.variantStyles, Badge);
export { Badge, BadgeBase, VariantBadge };
